import script from "./SettingsLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsLayout.vue?vue&type=script&setup=true&lang=js"

import "./SettingsLayout.vue?vue&type=style&index=0&id=30c250a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30c250a2"]])

export default __exports__